import {
    GET_DATA_NOTIF,
    GET_DATA_NOTIF_DOCS,
    GET_DATA_NOTIF_LOCK,
    CHANGE_NOTIF_STATUS,
} from 'constants/ActionTypes';


let INIT_STATE = {
    statusNotif: false,
    data_notif: [],
    data_notif_docs: [],
    data_notif_lock: []
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_DATA_NOTIF: {
            return {
                ...state,
                data_notif: action.payload
            }
        }
        case GET_DATA_NOTIF_DOCS: {
            return {
                ...state,
                data_notif_docs: action.payload
            }
        }
        case GET_DATA_NOTIF_LOCK: {
            return {
                ...state,
                data_notif_lock: action.payload
            }
        }
        case CHANGE_NOTIF_STATUS: {
            return {
                ...state,
                statusNotif: action.payload
            }
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./reducers/Notif.js